import { useMutation } from '@tanstack/react-query'
import type { McpAuthorizeRequest } from '@laplace/contracts'
import { apiClient } from '@/shared/api/client'

type McpAuthorizationDecision = 'approve' | 'deny'

export function useMcpAuthorization() {
  const mutation = useMutation({
    mutationKey: ['mcp', 'authorization'],
    mutationFn: async ({
      decision,
      request,
    }: {
      decision: McpAuthorizationDecision
      request: McpAuthorizeRequest
    }) =>
      decision === 'approve'
        ? apiClient.mcp.authorize(request)
        : apiClient.mcp.deny(request),
  })

  return {
    approve: (request: McpAuthorizeRequest) =>
      mutation.mutateAsync({ decision: 'approve', request }),
    deny: (request: McpAuthorizeRequest) =>
      mutation.mutateAsync({ decision: 'deny', request }),
    pending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  }
}
